import * as types from 'constants/ActionTypes';
import initialState from 'config/initialState';
import { getEndpointFromUrl } from 'utils';


function chargersList(chargersById, chargerIds, newChargers) {
  const newChargersById = {};
  const newChargerIds = [];
  const newReviewsById = {};
  const newImagesById = {};

  newChargers.forEach((charger) => {
    const changes = {};

    if (charger.reviews) {
      changes.reviews = charger.reviews.map((review) => {
        newReviewsById[review.pk] = Object.assign({}, review, {
          user: review.user ? review.user.pk || review.user : null,
          charger: charger.pk,
        });
        return review.pk;
      });

      changes.num_reviews = charger.reviews.length;
    }

    if (charger.places) {
      changes.places = charger.places.map(place => place.pk);
    }

    if (charger.images) {
      changes.images = charger.images.map((image) => {
        newImagesById[image.pk] = Object.assign({}, image, {
          charger: charger.pk,
          uploaded_by: image.uploaded_by.pk,
        });
        return image.pk;
      });
    }

    newChargersById[charger.pk] = Object.assign(
      {}, chargersById[charger.pk] || null, charger, changes);

    if (chargerIds.indexOf(charger.pk) === -1) {
      newChargerIds.push(charger.pk);
    }
  });

  return {
    byId: newChargersById,
    all: newChargerIds,
    reviewsById: newReviewsById,
    imagesById: newImagesById,
  };
}

function filterChargers(chargers, chargersById, filters) {
  let filteredChargers = [];
  const mappedChargers = [];

  if (filters.superchargers || filters.destinationChargers) {
    filteredChargers = chargers.filter((pk) => {
      const obj = chargersById[pk];

      if (filters.superchargers && filters.destinationChargers) return true;
      if (filters.superchargers) return obj.is_supercharger;
      return !obj.is_supercharger;
    });

    Object.keys(chargersById).forEach((pk) => {
      const obj = chargersById[pk];
      if (
        (filters.superchargers && filters.destinationChargers) ||
        (filters.superchargers && obj.is_supercharger) ||
        (filters.destinationChargers && !obj.is_supercharger)
      ) {
        mappedChargers.push(pk);
      }
    });
  }

  return { filteredChargers, mappedChargers };
}


export default function chargersReducer(state = initialState.chargers, action) {
  let results;
  let review;
  let modified;
  let byId = {};
  let all = [];
  const reviewsById = {};
  const imagesById = {};
  let chargerId;

  switch (action.type) {

    case types.CACHED_CHARGERS.SUCCESS:
      results = chargersList(state.byId, state.all, action.response.data);
      all = [...state.all, ...results.all];
      byId = Object.assign({}, state.byId, results.byId);
      return Object.assign({}, state, {
        byId,
        all,
        reviewsById: Object.assign({}, state.reviewsById, results.reviewsById),
        imagesById: Object.assign({}, state.imagesById, results.imagesById),
      }, filterChargers(all, byId, state.filters));

    case types.CHARGERS.SUCCESS:
      results = chargersList(state.byId, state.all, action.response.results);
      all = [...state.all, ...results.all];
      byId = Object.assign({}, state.byId, results.byId);
      return Object.assign({}, state, {
        byId,
        all,
        reviewsById: Object.assign({}, state.reviewsById, results.reviewsById),
        imagesById: Object.assign({}, state.imagesById, results.imagesById),
      }, filterChargers(all, byId, state.filters));

    case types.CHARGERS_NEAR_USER.REQUEST:
      return Object.assign({}, state, {
        nearUser: Object.assign({}, state.nearUser, {
          loading: true,
        }),
      });

    case types.CHARGERS_NEAR_USER.FAILURE:
      return Object.assign({}, state, {
        nearUser: Object.assign({}, state.nearUser, {
          loading: false,
          error: action.error,
        }),
      });

    case types.CHARGERS_NEAR_USER.SUCCESS: {
      results = chargersList(state.byId, state.all, action.response.results);
      all = [...state.all, ...results.all];
      byId = Object.assign({}, state.byId, results.byId);
      const nearUser = action.response.results.map(charger => charger.pk);
      return Object.assign({}, state, {
        byId,
        all,
        reviewsById: Object.assign({}, state.reviewsById, results.reviewsById),
        imagesById: Object.assign({}, state.imagesById, results.imagesById),
        nearUser: Object.assign({}, state.nearUser, {
          pagination: {
            next: getEndpointFromUrl(action.response.next),
            previous: getEndpointFromUrl(action.response.previous),
          },
          ids: nearUser,
          filtered: filterChargers(nearUser, byId, state.filters).filteredChargers,
          loading: false,
        }),
      }, filterChargers(all, byId, state.filters));
    }

    case types.CHARGERS_NEAR_USER_NEXT.REQUEST:
      return Object.assign({}, state, {
        nearUser: Object.assign({}, state.nearUser, {
          loading: true,
        }),
      });

    case types.CHARGERS_NEAR_USER_NEXT.FAILURE:
      return Object.assign({}, state, {
        nearUser: Object.assign({}, state.nearUser, {
          loading: false,
          error: action.error,
        }),
      });

    case types.CHARGERS_NEAR_USER_NEXT.SUCCESS: {
      results = chargersList(state.byId, state.all, action.response.results);
      all = [...state.all, ...results.all];
      byId = Object.assign({}, state.byId, results.byId);
      const newNearUserIds = action.response.results.map(charger => charger.pk);
      const allNearUserIds = [...state.nearUser.ids, ...newNearUserIds];
      return Object.assign({}, state, {
        byId,
        all,
        reviewsById: Object.assign({}, state.reviewsById, results.reviewsById),
        imagesById: Object.assign({}, state.imagesById, results.imagesById),
        nearUser: Object.assign({}, state.nearUser, {
          pagination: {
            next: getEndpointFromUrl(action.response.next),
            previous: getEndpointFromUrl(action.response.previous),
          },
          ids: allNearUserIds,
          filtered: filterChargers(allNearUserIds, byId, state.filters).filteredChargers,
          loading: false,
        }),
      }, filterChargers(all, byId, state.filters));
    }

    case types.CHARGERS_RANKED.SUCCESS:
      results = chargersList(state.byId, state.all, action.response.results);
      all = [...state.all, ...results.all];
      byId = Object.assign({}, state.byId, results.byId);
      return Object.assign({}, state, {
        byId,
        all,
        ranked: action.response.results.map(charger => charger.pk),
      }, filterChargers(all, byId, state.filters));

    case types.CHARGERS_NEAR_IP.SUCCESS: {
      results = chargersList(state.byId, state.all, action.response.results.data);
      const locationFromIp = action.response.results.location;
      all = [...state.all, ...results.all];
      byId = Object.assign({}, state.byId, results.byId);
      const changes = {
        byId,
        all,
        reviewsById: Object.assign({}, state.reviewsById, results.reviewsById),
        imagesById: Object.assign({}, state.imagesById, results.imagesById),
        locationFromIp,
      };
      if (!state.geolocation) {
        changes.chargerMap = {
          center: {
            lat: locationFromIp.latitude,
            lng: locationFromIp.longitude,
          },
          zoom: 10,
          selectedCharger: state.chargerMap.selectedCharger,
        };
      }
      return Object.assign({}, state, changes, filterChargers(all, byId, state.filters));
    }

    case types.GEOLOCATION.SUCCESS: {
      const updates = {
        geolocation: {
          allowed: true,
          coords: action.position,
        },
      };
      if (state.centerOnCurrentLocation) {
        updates.chargerMap = {
          center: {
            lat: action.position.lat,
            lng: action.position.lng,
          },
          zoom: state.chargerMap.zoom,
          selectedCharger: state.chargerMap.selectedCharger,
        };
      }
      return Object.assign({}, state, updates);
    }

    case types.GEOLOCATION.FAILURE:
      return Object.assign({}, state, {
        geolocation: {
          allowed: action.error.allowed,
          error: action.error.reason,
        },
      });

    case types.SET_CENTER_ON_CURRENT_LOCATION:
      return Object.assign({}, state, {
        centerOnCurrentLocation: action.value,
      });

    case types.CHARGER_REVIEWS.SUCCESS: {
      chargerId = parseInt(action.charger, 10);
      const reviews = action.response.results.map((chargerReview) => {
        reviewsById[chargerReview.pk] = Object.assign(
          {}, state.reviewsById[chargerReview.pk] || null, chargerReview, {
            charger: chargerId,
            user: chargerReview.user ? chargerReview.user.pk || chargerReview.user : null,
          },
        );
        return chargerReview.pk;
      });
      byId[chargerId] = Object.assign({}, state.byId[chargerId], {
        reviews,
        num_reviews: reviews.length,
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        reviewsById: Object.assign({}, state.reviewsById, reviewsById),
      });
    }

    case types.CHARGER_IMAGES.SUCCESS: {
      chargerId = parseInt(action.charger, 10);
      const images = action.response.results.map((image) => {
        imagesById[image.pk] = Object.assign({}, state.imagesById[image.pk] || null, image, {
          charger: chargerId,
          uploaded_by: image.uploaded_by ? image.uploaded_by.pk || image.uploaded_by : null,
        });
        return image.pk;
      });
      byId[chargerId] = Object.assign({}, state.byId[chargerId], { images });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        imagesById: Object.assign({}, state.imagesById, imagesById),
      });
    }

    case types.NEW_CHARGER_REVIEW: {
      chargerId = parseInt(action.charger, 10);
      review = action.review;
      reviewsById[review.pk] = Object.assign({}, review, {
        user: review.user ? review.user.pk || review.user : null,
        charger: chargerId,
      });
      modified = new Date(action.review.modified);
      const oldNumReviews = state.byId[chargerId].num_reviews || 0;
      const oldAverageRating = state.byId[chargerId].average_rating || 0;
      byId[chargerId] = Object.assign({}, state.byId[chargerId], {
        reviews: [review.pk, ...state.byId[chargerId].reviews],
        num_reviews: oldNumReviews + 1,
        average_rating: ((oldAverageRating * oldNumReviews) + review.rating) / (oldNumReviews + 1),
        user_review_status: {
          num_reviews: state.byId[chargerId].user_review_status.num_reviews + 1,
          last_reviewed: action.review.modified,
          next_review: modified.setDate(modified.getDate() + 30),
          can_review: false,
        },
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        reviewsById: Object.assign({}, state.reviewsById, reviewsById),
      });
    }

    case types.NEW_CHARGER_IMAGE:
      chargerId = parseInt(action.charger, 10);
      imagesById[action.image.pk] = Object.assign({}, action.image, {
        charger: chargerId,
        uploaded_by: (
          action.image.uploaded_by ? action.image.uploaded_by.pk || action.image.uploaded_by : null
        ),
      });
      byId[chargerId] = Object.assign({}, state.byId[chargerId], {
        images: [action.image.pk, ...state.byId[chargerId].images],
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        imagesById: Object.assign({}, state.imagesById, imagesById),
      });

    case types.CHARGER_PLACES.REQUEST:
      chargerId = parseInt(action.charger, 10);
      byId[chargerId] = Object.assign({}, state.byId[chargerId], { loadingPlaces: true });
      return Object.assign({}, state, { byId: Object.assign({}, state.byId, byId) });

    case types.CHARGER_PLACES.FAILURE:
      chargerId = parseInt(action.charger, 10);
      byId[chargerId] = Object.assign({}, state.byId[chargerId], { loadingPlaces: false });
      return Object.assign({}, state, { byId: Object.assign({}, state.byId, byId) });

    case types.CHARGER_PLACES.SUCCESS: {
      chargerId = parseInt(action.charger, 10);
      const newPlaceIds = [];
      const existingPlaceIds = state.byId[chargerId].places || [];
      action.response.results.forEach((place) => {
        if (existingPlaceIds.indexOf(place.pk) === -1) newPlaceIds.push(place.pk);
      });
      const loadedCategories = Object.assign({}, state.byId[chargerId].loadedCategories || null);
      if (action.args.include_simple_categories) {
        action.args.include_simple_categories.forEach((cat) => {
          if (!loadedCategories[cat]) loadedCategories[cat] = new Date();
        });
      }
      byId[chargerId] = Object.assign({}, state.byId[chargerId], {
        places: [...existingPlaceIds, ...newPlaceIds],
        loadingPlaces: false,
        loadedCategories,
        last_factual_update: state.byId[chargerId].last_factual_update || new Date(),
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
      });
    }

    case types.SET_CHARGER_SHOW_PLACE_CATEGORIES:
      return Object.assign({}, state, {
        showPlaceCategories: action.categories,
      });

    case types.SET_CHARGER_FILTER: {
      const filters = Object.assign({}, state.filters, action.filter);
      return Object.assign({}, state, {
        filters,
        nearUser: Object.assign({}, state.nearUser, {
          filtered: filterChargers(state.nearUser.ids, state.byId, filters).filteredChargers,
        }),
      }, filterChargers(state.all, state.byId, filters));
    }

    case types.CHANGE_MAP:
      if (action.center.lat !== 0 || action.center.lng !== 0) {
        return Object.assign({}, state, {
          chargerMap: {
            center: action.center,
            zoom: action.zoom,
            selectedCharger: state.chargerMap.selectedCharger,
          },
        });
      }
      return state;

    case types.USER.SUCCESS: {
      const reviewsByChargerId = {};
      if (action.response.charger_reviews) {
        action.response.charger_reviews.forEach((chargerReview) => {
          chargerId = chargerReview.charger.pk || chargerReview.charger;

          if (typeof chargerReview.charger === 'object') {
            byId[chargerReview.charger.pk] = Object.assign(
              {}, state.byId[chargerReview.charger.pk] || null, chargerReview.charger);
          }

          if (reviewsByChargerId[chargerId] === undefined) {
            reviewsByChargerId[chargerId] = [];
          }
          reviewsByChargerId[chargerId].push(chargerReview.pk);

          reviewsById[chargerReview.pk] = Object.assign(
            {}, reviewsById[chargerReview.pk] || null, chargerReview, {
              user: action.response.pk,
              charger: chargerReview.charger.pk,
            },
          );

          if (state.all.indexOf(chargerReview.charger.pk) === -1) {
            all.push(chargerReview.charger.pk);
          }
        });

        Object.keys(reviewsByChargerId).forEach((id) => {
          byId[id] = Object.assign({}, state.byId[id] || null, byId[id] || null, {
            reviews: reviewsByChargerId[id],
          });
        });

        return Object.assign({}, state, {
          byId: Object.assign({}, state.byId, byId),
          all: [...state.all, ...all],
          reviewsById: Object.assign({}, state.reviewsById, reviewsById),
        });
      }
      return state;
    }

    case types.CHARGER_MAP_CLICK:
      chargerId = parseInt(action.charger, 10);
      return Object.assign({}, state, {
        chargerMap: Object.assign({}, state.chargerMap, {
          selectedCharger: chargerId,
        }),
      });

    case types.SET_CURRENT_CHARGER:
      chargerId = parseInt(action.charger, 10);
      return Object.assign({}, state, {
        chargerMap: Object.assign({}, state.chargerMap, {
          selectedCharger: chargerId,
        }),
      });

    case types.COUNTRIES.SUCCESS: {
      const countriesById = {};
      const countries = action.response.results.map((country) => {
        countriesById[country.pk] = country;
        return country.pk;
      });
      return Object.assign({}, state, {
        countries,
        countriesById: Object.assign({}, state.countriesById, countriesById),
      });
    }

    case types.STATES.SUCCESS: {
      const statesById = {};
      const states = action.response.results.map((geoState) => {
        statesById[geoState.pk] = geoState;
        return geoState.pk;
      });
      return Object.assign({}, state, {
        states,
        statesById: Object.assign({}, state.statesById, statesById),
      });
    }

    case types.NEW_PLACE: {
      const place = action.data;
      chargerId = place.charger;
      byId[chargerId] = Object.assign({}, state.byId[chargerId], {
        places: [...state.byId[chargerId].places, place.pk],
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
      });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/scripts/reducers/ChargerReducers.js